import axios from '@/libs/http'


/**
 * 店员PK
 */
export const getList = (status, pageNo, pageSize) => {
    return axios.request({
        url: '/s/c/clerk-pk/list',
        params: {
            status,
            pageNo,
            pageSize,
        },
        method: 'get'
    })
}

/**
 * 获取当前pk的信息
 */
export const getCreatePkInfo = () => {
    return axios.request({
        url: '/s/c/clerk-pk/getCreatePkInfo',
        method: 'get'
    })
}
/**
 * 获取pk的信息
 */
export const getPKInfo = (id) => {
    return axios.request({
        url: '/s/c/clerk-pk/getPKInfo',
        params: {
            id,
        },
        method: 'get'
    })
}